import { createHashRouter } from 'react-router-dom';
import RouteManager from './RouteManager';
import MainLayout from '../components/layout/MainLayout/MainLayout';
import NotFound from '../pages/NotFound';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import Activate from '../pages/auth/Activate';
import Forgot from '../pages/auth/Forgot';
import Reset from '../pages/auth/Reset';
import Logout from '../pages/auth/Logout';
import Dashboard from '../pages/dashboard/Dashboard';
import Reminders from '../pages/reminders/Reminders';
import AddReminder from '../pages/reminders/AddReminder';
import EditReminder from '../pages/reminders/EditReminder';
import ReminderLogs from '../pages/reminders/ReminderLogs';
import Settings from '../pages/settings/Settings';
import Workers from '../pages/workers/Workers';
import AddWorker from '../pages/workers/AddWorker';
import ViewWorker from '../pages/workers/ViewWorker';
import Notifications from '../pages/notifications/Notifications';
import Todos from '../pages/todos/Todos';
import AddTodo from '../pages/todos/AddTodo';
import EditTodo from '../pages/todos/EditTodo';
import TodoTags from '../pages/todos/TodoTags';

export const router = createHashRouter([
  {
    element: <RouteManager />,
    children: [
      // Public auth-related routes
      { path: '/login', element: <Login /> },
      { path: '/register', element: <Register /> },
      { path: '/activate', element: <Activate /> },
      { path: '/forgot', element: <Forgot /> },
      { path: '/reset', element: <Reset /> },
      // Protected app area (no ProtectedRoute needed)
      {
        path: '/',
        element: <MainLayout />,
        errorElement: <NotFound />,
        children: [
          { path: 'dashboard', element: <Dashboard /> },
          { path: 'settings', element: <Settings /> },
          { path: 'logout', element: <Logout /> },
          { path: 'notifications', element: <Notifications /> },
          { path: 'reminders', element: <Reminders /> },
          { path: 'reminders/add', element: <AddReminder /> },
          { path: 'reminders/edit', element: <EditReminder /> },
          { path: 'reminders/logs', element: <ReminderLogs /> },
          { path: 'workers', element: <Workers /> },
          { path: 'workers/add', element: <AddWorker /> },
          { path: 'workers/view', element: <ViewWorker /> },
          { path: 'todos', element: <Todos /> },
          { path: 'todos/add', element: <AddTodo /> },
          { path: 'todos/edit', element: <EditTodo /> },
          { path: 'todos/tags', element: <TodoTags /> },
        ],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

export default router;
